<div class="content">
    <em class="fa fa-circle-o-notch fa-spin"></em>
    <span>{{status}}</span>
</div>
